require('./brokerWarrantsSellExAnteDetails.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');

// @ helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const {
    formatAmount,
    formatCurrency,
    formatWithoutRound,
} = require("utilities/currencyHelper");

// @ components
const BrokerExAntSection = require("components/commons/brokerExAntSection/brokerExAntSection");
const BrokerDataItem = require("components/commons/brokerDataItem/brokerDataItem");
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ constants
const {
    BROKER_ORDER_TYPE_TO_MARKET,
    BROKER_ORDER_TYPE_FOR_THE_BEST,
    BROKER_ORDER_TYPE_LIMITED,
    BROKER_TYPE_STOCKS_NEW_DECIMALS,
    CHARGE_ACCOUNT_PREFIX
} = require("constants/index");
const { DATE_PICKER_CUSTOM_DATE_FORMAT } = require('constants/commonsComponents');

class BrokerWarrantsSellExAnteDetails extends React.Component {
    buildRightSide() {
        const { immBrokerWarrantsSell } = this.props;
        return immBrokerWarrantsSell
            .get("exAnteData")
            .map((item, index) => (
                <BrokerExAntSection
                    context="brokerWarrantsSell"
                    eventCategory="orden venta acciones/paso 2"
                    section={item}
                    key={index}
                    complexTooltip={true}
                />
            ));
    }

    buildContent() {
        const {
            productCurrency,
            productFile,
            step1,
            stockContract,
            stockDescription,
            immBrokerWarrantsSell,
        } = this.props;
        const market = !!productFile.get("marketName")
            ? productFile.get("marketName").trim()
            : "";
        const stockToSell = `${stockDescription} ${market}`;
        const sharesAmount = step1.get('titleQuantity', 0);
        const sellPrice = step1.get('sellPrice', 0);
        let estimatedAmount = `${formatWithoutRound(sharesAmount*sellPrice)} ${formatCurrency(productCurrency)}`
        const estimatedBaseAmount = immBrokerWarrantsSell.get('estimatedBaseAmount');
        const estimatedBaseAmountExchanged = immBrokerWarrantsSell.get('estimatedBaseAmountExchanged');
        if(!!estimatedBaseAmount){
            const estimatedBaseAmountValue = estimatedBaseAmount.get('amount');
            const estimatedBaseAmountCurrency = estimatedBaseAmount.get('currency');
            if (!!estimatedBaseAmountExchanged) {
                const estimatedBaseAmountExchangedValue=estimatedBaseAmountExchanged.get('amount');
                const estimatedBaseAmountExchangedCurrency=estimatedBaseAmountExchanged.get('currency')
                estimatedAmount = `${formatWithoutRound(
                    estimatedBaseAmountValue,
                    2
                )} ${formatCurrency(
                    estimatedBaseAmountCurrency
                )} | ${formatWithoutRound(
                    estimatedBaseAmountExchangedValue,
                    2
                )} ${formatCurrency(estimatedBaseAmountExchangedCurrency)}`;
            } else {
                estimatedAmount = `${formatWithoutRound(
                    estimatedBaseAmountValue,
                    2
                )} ${formatCurrency(estimatedBaseAmountCurrency)}`;
            }
        }
        const orderTypeOption = step1.get('orderTypeOption');
        let orderType;
        switch (orderTypeOption) {
            case BROKER_ORDER_TYPE_TO_MARKET:
                orderType = formatText('broker-stocksSellOrderTypeOption1');
                break;
            case BROKER_ORDER_TYPE_FOR_THE_BEST:
                orderType = formatText('broker-stocksSellOrderTypeOption2');
                break;
            case BROKER_ORDER_TYPE_LIMITED:
                const currency = formatCurrency(productCurrency)
                const limitValueText = formatAmount(
                    step1.get("orderTypeValue"),
                    undefined,
                    BROKER_TYPE_STOCKS_NEW_DECIMALS
                ).toString();
                orderType = formatText('broker-stocksSellOrderTypeOption3', [limitValueText, currency]);
                break;
            default:
                orderType = '-'
                break;
        }
        const validityDate = !!step1.get("validityDate")
            ? step1.get("validityDate")
            : null;
        const formattedValidityDate = !!validityDate
            ? validityDate.format(formatText(DATE_PICKER_CUSTOM_DATE_FORMAT))
            : '-';

        const contractValues = `${CHARGE_ACCOUNT_PREFIX}${stockContract.get(
            "controlDigit"
        )}${stockContract.get("productNumber")}${stockContract.get(
            "walletNumber"
        )}`
        const accountType = stockContract.get('associatedAccountAlias');
        const accountNumber =stockContract.get('associatedAccount');
        const walletBalance = stockContract.getIn(['associatedAccountBalance', 'amount']);
        const walletCurrency = stockContract.getIn(['associatedAccountBalance', 'currency']);
        const accountBalance = `${formatAmount(walletBalance)} ${formatCurrency(walletCurrency)}`
        const accountDetails = formatText(
            "brokerStocksSells-asociatedAccountDetails",
            [accountType, accountNumber, accountBalance]
        );


        return (
            <div className="warrants-sell-step2-exante__container">
                <div className="warrants-sell-step2-exante__left">
                    <div className="warrants-sell-step2-exante__subtitle">
                        <FormattedText value="brokerInternalTransferFund-ExantCost_OrderDataSubtitle" />
                    </div>
                    <BrokerDataItem
                        label="brokerWarrantsSell-warrantToSellLabel"
                        data={stockToSell}
                    />
                    <BrokerDataItem
                        label="brokerWarrantsSell-estimatedAmountLabel"
                        data={estimatedAmount}
                        tooltipTitleKey="brokerWarrantsSell-estimatedAmountTooltipTitle"
                        tooltipContentKey="brokerWarrantsSell-estimatedAmountComplexTooltipContent"
                        eventCategory="orden venta acciones/paso 2"
                        eventTag={formatText("brokerWarrantsSell-orderData_estimatedAmount_eventTag")}
                        complexTooltip
                    />
                    <BrokerDataItem
                        label="brokerWarrantsSell-sharesLabel"
                        data={sharesAmount}
                    />
                    <BrokerDataItem
                        label="brokerWarrantsSell-orderTypeLabel"
                        data={orderType}
                    />
                    <BrokerDataItem
                        label="brokerWarrantsSell-validityPeriodLabel"
                        data={formattedValidityDate}
                    />
                    <BrokerDataItem
                        label="brokerWarrantsSell-contractLabel"
                        data={contractValues}
                    />
                    <BrokerDataItem
                        label="brokerWarrantsSell-firstOwnerLabel"
                        data={stockContract.get('firstTitular')}
                    />
                    <BrokerDataItem
                        label="brokerWarrantsSell-asociatedAccountLabel"
                        data={accountDetails}
                    />
                </div>
                <div className="warrants-sell-step2-exante__right">
                    {this.buildRightSide()}
                </div>
            </div>
        );
    }

    render() {
        const { immBrokerWarrantsSell } = this.props;
        if(immBrokerWarrantsSell.get('exAnteDataFetching')){
            return <LoadingSection/>
        }
        const content = this.buildContent();
        return __CONTACT_CENTER__ ? (
            <BlockInfo extraClass="warrants-sell-step2-exante__cc-container">
                <div className="warrants-sell-step2-exante__cc-header-text">
                    <FormattedText value="brokerWarrantsSell-exAnteHeaderTextCC" />
                </div>
                {content}
                <div className="warrants-sell-step2-exante__cc-footer-text">
                    <FormattedText value="brokerWarrantsSell-exAnteBottonTextCC" />
                </div>
            </BlockInfo>
        ) : (
            <div>
                {content}
            </div>
        );
    }

}

BrokerWarrantsSellExAnteDetails.propTypes = {
    productCurrency: PropTypes.string,
    productFile: PropTypes.object,
    step1: PropTypes.object,
    immBrokerWarrantsSell: PropTypes.object,
    stockContract: PropTypes.object,
    stockDescription: PropTypes.string,
}



module.exports = BrokerWarrantsSellExAnteDetails;
